export default [
    //PRESUMPTIVE SECTION
    {
        path: "/presumptive/townships",
        name: "pre-townships",
        component: () => import("@/views/presumptive/Township.vue"),
        meta: { forAuth: true },
    },
    {
        path: "/presumptive/:township_id",
        name: "presumptive",
        component: () => import("@/views/presumptive/Presumptive.vue"),
        meta: { forAuth: true },
    },
    {
        path: "/create/presumptive/:township_id/:type",
        name: "create-presumptive",
        component: () => import("@/views/presumptive/CreatePst.vue"),
        meta: { forAuth: true },
    },
    {
        path: "/presumptive-list/:township_id",
        name: "presumptive-list",
        component: () => import("@/views/presumptive/PresumptiveList.vue"),
        meta: { forAuth: true },
    },
    {
        path: "/presumptive-detail/:id",
        name: "presumptive-detail",
        component: () => import("@/views/presumptive/PresumptiveDetail.vue"),
        meta: { forAuth: true },
    },
    {
        path: "/add/presumptive-times/:id/:type/:township_id",
        name: "add-presumptive-times",
        component: () => import("@/views/presumptive/AddTimes.vue"),
        meta: { forAuth: true },
    },
    {
        path: "/edit-presumptive-times/:id",
        name: "edit-presumptive-times",
        component: () => import("@/views/presumptive/EditTimes.vue"),
        meta: { forAuth: true },
    },
    {
        path: "/presumptive-edit/:id",
        name: "presumptive-edit",
        component: () => import("@/views/presumptive/EditInfo.vue"),
        meta: { forAuth: true },
    },
    {
        path: "/presumptive-referral/:township_id",
        name: "presumptive-referral",
        component: () => import("@/views/presumptive/referral/PresumptiveReferral.vue"),
        meta: { forAuth: true },
    },
    {
        path: "/presumptive-referral/edit/:id/:township_id",
        name: "presumptive-referral-edit",
        component: () => import("@/views/presumptive/referral/EditPresumptiveReferral.vue"),
        meta: { forAuth: true },
    },

    //ci
   
    {
        path: "/ci/townships",
        name: "ci-township",
        component: () => import("@/views/ci/Township.vue"),
        meta: {
          forAuth: true,
        },
      },
      {
        path: "/ci/:township_id",
        name: "ci",
        component: () => import("@/views/ci/Ci.vue"),
        meta: { forAuth: true },
      },

      {
        path: "/ci-list/:month/:year/:township_id",
        name: "ci-list",
        component: () => import("@/views/ci/CiList.vue"),
        meta: { forAuth: true },
      },

      {
        path: "/create/ci/activity/:month/:year/:township_id",
        name: "create-ci",
        component: () =>
            import ("@/views/ci/Create.vue"),
        meta: { forAuth: true, },
    },
    {
        path: "/edit/ci/activity/:id/:month/:year/:township_id",
        name: "edit-ci",
        component: () => import("@/views/ci/Edit.vue"),
        meta: { forAuth: true },
      },
   
    
]